import pushDataLayer from '~/mixins/gtm/push-data-layer'

export default {
  mixins: [pushDataLayer],
  mounted() {
    const errorMessage = this.$route.query.error_message
    if (errorMessage) this.checkoutErrorMessage(Number(errorMessage))
  },

  methods: {
    goToCheckout() {
      // eslint-disable-next-line camelcase
      if (this.cart?.line_items?.length) {
        this.pushDataLayer({
          event: 'genericEvent',
          eventCategory: 'clickOnButton',
          eventAction: 'initiateCheckout',
          eventValue: { ...this.cartToGtm, ...this.$store.getters.sessionInfo },
        })
      }
      const checkoutUrl = this.$isBrStore
        ? this.$config.checkoutURL
        : `${this.$config.checkoutGlobalURL}?language=${this.$store.state.locale}`

      this.$nextTick(() => {
        window.open(checkoutUrl, '_self')
      })
    },
    checkoutErrorMessage(number) {
      if (number) {
        const messageCode = {
          1: 'first',
          2: 'second',
          3: 'third',
          4: 'fourth',
          5: 'fifth',
          6: 'sixth',
          7: 'seventh',
          8: 'eighth',
        }[number]

        this.$displayTopMessage(
          this.$t(`checkout.error_message.${messageCode}`),
          {
            type: 'error',
          }
        )
      }
    },
  },
}
